// extracted by mini-css-extract-plugin
export default {"overlay":"styles-module__overlay___eHW0d","logo":"styles-module__logo___IyN7y","spinner":"styles-module__spinner___TCxJQ","srOnly":"styles-module__srOnly___bEfwp"};